import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { NumberFormatter } from '../NumberFormatter/NumberFormatter';
import { CurrencySymbol } from './CurrencySymbol';
export interface INewAmountInputProps {
  id?: string;
  e2e: string;
  value: Nullable<number>;
  precision?: number;
  currency: string;
  decimalPadding?: boolean;
  tabIndex?: number;
  prepend?: ReactNode;
  className?: string;
}

export const ReadOnlyAmount: FC<INewAmountInputProps> = ({
  value,
  currency,
  e2e,
  precision,
  decimalPadding,
  id,
  tabIndex,
  prepend,
  className,
}) => {
  return (
    <div className="with-unit-component input-group" data-e2e="NotionalAmount-with-unit">
      {prepend}
      <span className="text-secondary input-group-text">
        <CurrencySymbol code={currency} />
      </span>
      <NumberFormatter
        value={value}
        e2e={e2e}
        className={classNames('text-end', className)}
        precision={precision}
        decimalPadding={decimalPadding}
        id={id}
        tabIndex={tabIndex}
        isReadOnly={true}
      />
    </div>
  );
};
ReadOnlyAmount.displayName = 'ReadOnlyAmount';
